// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchRecommendedItemParams = {
    amazon: boolean,
    authToken: string,
    bidderId: number,
    deployment: string,
};

export default {
    fetchRecommendedItem: ({ amazon, authToken, bidderId, deployment }: FetchRecommendedItemParams) =>
        new Promise<any>((resolve, reject) => {
            const path = amazon ? '<PERSONALIZE-API>' : '<RECOMMENDATION-API>';
            const apiPath = amazon ? `${bidderId}` : '';
            const request = makeGet({ apiPath, authToken, deployment, path, useCacheKey: false });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
